import { array, defineAction, number, object, string } from '~/prix'
import geocodeAddressAction from './geocodeAddress.action.json'

// city, country, neighborhood, number, state, street

const geocodeAddressDefinition = defineAction({
  ...geocodeAddressAction,
  input: object({
    address: string().label('Endereço completo a ser geocodificado.'),
    include: array(string()).label('Incluir informações adicionais no resultado.').isOptional(),
    limit: number().label('Limite de resultados a serem retornados.').isOptional(),
    number: string().label('Número do endereço a ser geocodificado.').isOptional(),
  }),
  output: object({}),
})

export default geocodeAddressDefinition
